import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import selectors from '../../../../store/shared/selectors'
import { Field, reduxForm } from 'redux-form'
import renderSliderInput from '../../../../components/ui/forms/renderSliderInput'

class AmortizationSliderForm extends Component {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    formValues: PropTypes.any.isRequired,
  }

  render() {
    const { formValues, onChange } = this.props
    return (
      <form onChange={() => setTimeout(() => {onChange()}, 100)}>
        <Field
          display={`${formValues.rate || 0}%`}
          name="rate"
          label="Interest Rate"
          min={0.5}
          max={15}
          step={0.5}
          component={renderSliderInput}
          tipContent="Subsidized loans are generally under 5% interest. Lower interest-rates mean less money to pay back."
        />
        <div style={{marginTop: 10}}/>
        <Field
          display={`${formValues.term || 0} years`}
          name="term"
          label="Loan Term"
          min={5}
          max={30}
          step={5}
          component={renderSliderInput}
          tipContent="Shorter payback periods lower your total cost but increase your monthly payments."
        />
      </form>
    )
  }
}

const validate = values => {
  const errors = {}

  if (!values.state) {
    errors.state = 'Required'
  }

  return errors
}

const wrappedWithForm = reduxForm({
  form: 'amortizationSliderForm',
  validate,
})(AmortizationSliderForm)

const makeMapStateToProps = () => {
  const getFormValues = selectors.makeGetFormValues()
  return state => ({
    formValues: getFormValues(state.form.amortizationSliderForm)
  })
}

export default connect(makeMapStateToProps)(wrappedWithForm)



// WEBPACK FOOTER //
// ./src/routes/authenticated/Tuition/components/AmortizationSliderForm.js